import { render, staticRenderFns } from "./ProveedorList.vue?vue&type=template&id=0b336054&scoped=true&"
import script from "./ProveedorList.vue?vue&type=script&lang=js&"
export * from "./ProveedorList.vue?vue&type=script&lang=js&"
import style0 from "./ProveedorList.vue?vue&type=style&index=0&id=0b336054&lang=scss&scoped=true&"
import style1 from "./ProveedorList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ProveedorList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b336054",
  null
  
)

export default component.exports